/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-25 10:06:15
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-09-28 13:06:55
 * @FilePath: \hlweb2.0\src\pages\Solution\Archives\CoreContent\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import "./index.scss";
function CoreContent() {
  const history = useHistory()
  const [activeIndex, setActiveIndex] = useState(null);
  const { t } = useTranslation();
  const corecontentCenter = t("solution_infoServices.infoServices3", {
    returnObjects: true,
  });
  
  const click = () => {
    history.push("/apply");
  };
  return (
    <div className="corecontent_">
      <div className="edition_solution edition_solution_top">
        <div className="edition_solution_title">
          <div>{corecontentCenter.til}</div>
          <span>{corecontentCenter.dil}</span>
        </div>
      </div>
      <div className="corecontent_con">
        {corecontentCenter.contractList.map((item0, index0) => {
          return (
            <div
              className="corecontent_li"
              key={index0}
              onMouseEnter={() => {
                setActiveIndex(index0);
              }}
              onMouseLeave={() => setActiveIndex(null)}
            >
              <img className="corecontent_li_img" src={item0.imgUrl} alt="" />
              <div className="corecontent_li_body">
                <div className="corecontent_li_label">{item0.label}</div>
                <div className="corecontent_li_til">{item0.title}</div>
                <div className="corecontent_li_con">{item0.text}</div>
                <ul className="corecontent_li_card">
                  {item0.list.map((item1, index1) => {
                    return (
                      <li key={index0 + index1}>
                        <div className="card_img">
                          <img src={require('../../../../assets/images/solution/infoServices/icon.png').default}/>
                        </div>
                        <div className="card_con">{item1}</div>
                      </li>
                    );
                  })}
                </ul>
              </div>
              <div className="corecontent_li_div">
              </div>
              <div className="corecontent_li_footer">
                <div className="corecontent_li_footer_con"></div>
                <div className="corecontent_li_footer_jump" onClick={() => click()}>{corecontentCenter.jumpText}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default CoreContent;
